module.exports = __webpack_public_path__ + "static/media/map-coach-icon.d95ba561.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/map-coach-icon.svg
// module id = 856
// module chunks = 0